import { render } from "./SchoolServiceEditContainer.vue?vue&type=template&id=00f7db51&ts=true"
import script from "./SchoolServiceEditContainer.vue?vue&type=script&lang=ts"
export * from "./SchoolServiceEditContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__